<template>
	<li :class="{'margin-right-0':margin_right_0,'big':size=='big'}" :style="itemStyle">
		<router-link :to="url">
			<div class="item-bofang">
				<svg class="bofang-icon" viewBox="0 0 1024 1024">
					<path
						d="M512 512m-490.6624 0a490.6624 490.6624 0 1 0 981.3248 0 490.6624 490.6624 0 1 0-981.3248 0Z"
						fill="#000000" fill-opacity=".3"></path>
					<path
						d="M512 0c282.7648 0 512 229.2352 512 512S794.7648 1024 512 1024 0 794.7648 0 512 229.2352 0 512 0z m0 25.6C243.3664 25.6 25.6 243.3664 25.6 512s217.7664 486.4 486.4 486.4 486.4-217.7664 486.4-486.4S780.6336 25.6 512 25.6z"
						fill="#FFFFFF"></path>
					<path d="M426.6624 341.3376v341.3248L704 522.0352z" fill="#FFFFFF"></path>
				</svg>
			</div>
			<div class="img-box">
				<img class="one-img" :src="img">
			</div>
			<p class="one-title" :title="title">{{title}}</p>
			<p class="one-name">{{label1}}&nbsp;|&nbsp;{{label2}} </p>
		</router-link>
	</li>
</template>

<script>
	export default {
		props: {
			title: {
				type: String
			},
			size: {
				type: String
			},
			img: {
				type: String
			},
			label1: {
				type: String
			},
			label2: {
				type: String
			},
			url: {
				type: String
			},
			margin_right_0: {
				type: Boolean,
				default () {
					return false
				}
			},
			itemStyle: {
				type: Object,
				default () {
					return {}
				}
			}
		}
	}
</script>

<style scoped >
	p {
		margin: 0;
	}

	li {
		margin-right: 20px;
		float: left;
		height: 200px;
		margin-top: 20px;
		position: relative;
		cursor: pointer;
		list-style: none;
		vertical-align: bottom;
		list-style-type: none;
	}
	
	li a {
		text-decoration: none !important;
		color: #777;
		outline: none;
	}
	
	li a .item-bofang {
		position: absolute;
		width: 240px;
		height: 135px;
		background: rgba(0, 0, 0, 0.6);
		text-align: center;
		border-radius: 4px;
		box-sizing: border-box;
		transition: all 0.6s;
		-webkit-transition: all 0.6s;
		-o-transition: all 0.6s;
		-moz-transition: all 0.6s;
		-ms-transition: all 0.6s;
		opacity: 0;
		z-index: 1;
		top: 0px;
		padding-top: 47.5px;
	}
	
	li a .item-bofang .bofang-icon {
		width: 48px;
		height: 48px;
	}
		
	li a .img-box {
		width: 240px;
		height: 135px;
		overflow: hidden;
		border-radius: 4px;
	}
	
	li a .img-box .one-img {
		width: 240px;
		height: 135px;
		object-fit: cover;
		transition: all 0.6s;
		-webkit-transition: all 0.6s;
		-o-transition: all 0.6s;
		-moz-transition: all 0.6s;
		-ms-transition: all 0.6s;
	}
		
	li a .one-title {
		line-height: 24px;
		margin-top: 10px;
		font-size: 16px;
		color: #2A2A2A;
		overflow: hidden;
		width: 240px;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-weight: 500;
	}
		
	li a .one-title:hover {
		color: rgb(61, 132, 255)
	}
		
	li a .one-name {
		line-height: 20px;
		margin-top: 10px;
		font-size: 14px;
		color: #9C9C9C;
		overflow: hidden;
		width: 240px;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	li:hover .item-bofang {
		opacity: 1;
	}

	li:hover img {
		transform: scale(1.1);
	}

	li.big {
		height: 300px;
	}
	
	li.big .item-bofang {
		width: 360px;
		height: 202.5px;
		padding-top: 80px;
	}
	
	li.big .img-box {
		width: 360px;
		height: 202.5px;
	}
	
	li.big .img-box .one-img {
		width: 360px;
		height: 202.5px;
	}
	
	li.big .one-title {
		width: 360px;
	}
	
	li.big .one-name {
		width: 360px;
	}

	@media screen and (max-width: 1380px) {
		li:nth-child(5) {
			margin-right: 0;
		}
	}

	.margin-right-0 {
		margin-right: 0;
	}
</style>
